import React from "react";
import useGet from "../hooks/useGet";
import { Apis } from "../util/Apis";
import CustomLoading from "./CustomLoading";
import NoSorteos from "./NoSorteos";
import Text from "../styledComponents/TextStyled";
import { BackgroundListRaffle } from "../pages/SorteoList";
import EmptyState from "./EmptyState";
import CardTorneo from "./CardTorneo";

const TorneoListTab = () => {
  const {
    data: dataTorneos,
    loading: loadingTorneos,
    error: errorTorneos,
  } = useGet({
    url: `${Apis.SORTEOS}/torneos/active/v2`,
    initialValue: [],
  });

  return (
    <>
      {loadingTorneos ? (
        <CustomLoading />
      ) : errorTorneos ? (
        <NoSorteos>
          <Text textStyle="small" color="red">
            {errorTorneos.message || "Ocurrió un error al cargar los torneos"}
          </Text>
        </NoSorteos>
      ) : dataTorneos?.length > 0 ? (
        <BackgroundListRaffle className="custom-scroll">
          {dataTorneos.map((item) => (
            <CardTorneo key={item.id} item={item} />
          ))}
        </BackgroundListRaffle>
      ) : (
        <EmptyState variant="torneos" />
      )}
    </>
  );
};

export default TorneoListTab;
